import Breadcrumb from "../../Pages/Breadcrumb";
import img1 from "../../../assets/service/plateform1.png";
import img2 from "../../../assets/service/plateform2.png";
import img3 from "../../../assets/service/plateform3.png";
import img4 from "../../../assets/service/plateform4.png";
import img5 from "../../../assets/service/plateform9.png";
import img6 from "../../../assets/service/plateform6.png";
import img7 from "../../../assets/service/plateform7.png";
import img8 from "../../../assets/service/plateform8.png";
import img9 from "../../../assets/service/plateform10.png";
import ServiceApplyBtn from "../../ui/ServiceApplyBtn";
import { useTranslation } from "react-i18next";

const TrainingCard = ({ title, description, image }) => {
    return (
        <div className="bg-white rounded-lg text-center overflow-hidden relative border">
            <div className="relative w-full h-[200px] overflow-hidden">
                <img
                    src={image}
                    alt={title}
                    className="w-full h-full object-cover relative"
                />
                <div className="bg-light-red absolute w-full h-full top-0"></div>
                <h3 className="absolute text-2xl font-bold m-0 text-white top-20 left-1/2 transform -translate-x-1/2">{title}</h3>
            </div>
            <div className="!p-4 text-center text-lg text-common-text">
                <p className="m-0">{description}</p>
            </div>
        </div>
    );
};

const Platforms = () => {
    const { t } = useTranslation();
    const cards = t('platforms.cards', { returnObjects: true });
    const imgs = [img1, img2, img3, img4, img5, img6, img7, img8, img9];
    return (
        <>
            <Breadcrumb pages={[t('routes.services'), t('routes.platforms')]} />
            <div className="container">
                <div>
                    <div className="border rounded-lg my-10">
                        <div>
                            <h2 className="bg-primary-tw text-white !py-2 px-5 rounded-lg inline-block text-2xl relative h-[50px] top-[-25px] min-w-[300px]">
                                {t('routes.platforms')}
                            </h2>
                            <p className="mb-4 text-semi-gray text-xl">
                                {t('platforms.desc')}
                            </p>
                        </div>
                    </div>

                    <div className="grid lg:grid-cols-2 xl:grid-cols-3 !gap-8">
                        {cards.map((card, i) => (
                            <TrainingCard key={i} title={card?.tip} description={card?.text} image={imgs[i]} />
                        ))}
                    </div>

                    <ServiceApplyBtn serviceId={4} serviceName={t('routes.platforms')} />
                </div>
            </div>
        </>
    );
};

export default Platforms;